import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Startup Prototype Development?",
    answer: `<p>It's the process of developing a preliminary model of your business concept, providing a tangible representation for testing and refinement.</p>`,
  },
  {
    question: "Why is Prototype Development crucial for startups?",
    answer: ` <p>Prototypes validate ideas, attract investors, aid in market testing, and work as a roadmap for product development, decreasing risks.</p>`,
  },
  {
    question: "How does your company approach Prototype Development?",
    answer: `<p>We follow a thorough process, merging ideation, design, and iteration to guarantee accuracy and adaptability to market variations.</p>`,
  },
  {
    question: "Can you handle industry-specific prototypes?",
    answer: `<p>Yes, our skills extend to modifying prototypes to certain industries, improving relevance and market competitiveness.</p>`,
  },
  {
    question: "What's the timeline for prototype completion?",
    answer: ` <p>Timelines change based on project complexity, but we prioritize productivity without negotiating the quality of the prototype.</p>`,
  },
  {
    question: "How do prototypes assist in investor pitches?",
    answer: ` <p>Prototypes offer a perceptible and persuasive vision, displaying the potential of your startup and significantly swaying investor decisions.</p>`,
  },
  {
    question: "Do you provide post-prototype development services?",
    answer: `<p>Absolutely, our services extend beyond prototypes. We help in further development, evaluation, and improvement for a complete startup journey.</p>`,
  },
  {
    question: "How do I get started with your Startup Prototype Services?",
    answer: `<p>Contact us via our website, share your idea, and our team will guide you through the process, warranting an effortless start to your project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Startup Prototype Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
